import { useRef } from 'react';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, TextArea } from 'components/common/form';
import { useDispatch, useReduxState } from 'hooks';

const SiteSettingsThemesImport = ({ onImport, themeId }) => {
  const textAreaContainer = useRef<HTMLDivElement>(undefined);

  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const handleModalVisible = () => {
    textAreaContainer.current?.querySelector('textarea').focus();
  };

  const submit = async (values) => {
    const data = JSON.parse(values.data);
    await api.put(`/admin/server-themes/${themeId}`, { importData: data });
    await onImport();
    dispatch(
      actions.addNotice({
        text: messages.siteThemesUpdateSuccess,
        type: 'success'
      })
    );
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="file-import"
      buttonText={messages.siteThemesImportData}
      modalActionText={messages.commonImport}
      modalTitle={messages.siteThemesImportData}
      onModalVisible={handleModalVisible}
      onSubmit={submit}
      pristineIsValid={false}
    >
      {(formState) => (
        <FormGroup htmlFor="theme-import-data" label={messages.commonData}>
          <TextArea
            field="data"
            id="theme-import-data"
            placeholder={messages.commonPasteData}
            textareaContainerRef={(el) => (textAreaContainer.current = el)}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default SiteSettingsThemesImport;
